// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton__skeleton--2Pa","shine":"Skeleton__shine--13U"};